import { getAdvancedFiltersUserPreferenceSelector } from "./getAdvancedFiltersUserPreferenceSelector";
import { RootState } from "../../../../store";

export const getRightsizingAdvancedFiltersSettingsLoadingSelector = (
  state: RootState,
) => {
  return getAdvancedFiltersUserPreferenceSelector(state)?.isLoading;
};
